// extracted by mini-css-extract-plugin
export default {"label":"Slider_label__Ew7nE","grid":"Slider_grid__MnQkA","input":"Slider_input__O7zgj","inputProps":"Slider_inputProps__u3Hut"};